import { gql, useMutation } from '@apollo/client';

export const CHANGE_EMPLOYEE_AVATAR = gql`
  mutation changeMemberAvatar($memberId: ObjectId!, $avatar: Upload) {
    changeMemberAvatar(memberId: $memberId, avatar: $avatar) {
      profile {
        avatarUrl
      }
    }
  }
`;

export const useChangeEmployeeAvatar = () => {
  const [changeEmployeeAvatar] = useMutation(CHANGE_EMPLOYEE_AVATAR);

  return changeEmployeeAvatar;
};
